/**
 * NonNavPages.js
 *
 * This file contains all the route that are not under menu
 */

import View from '@/components/componentView.vue';
import { NON_NAV_PAGES } from '@/constants/pageTitles';
import Legal from '../views/Legal.vue';
import Search from '../views/Search.vue';

import { LEGAL, SEARCH_RESULT_NOT_FOUND, SEARCH_RESULT_FOUND, HOME } from './routeNames';

export default [
  {
    path: 'extra',
    component: View,
    children: [
      {
        path: '',
        redirect: {
          name: HOME,
        },
      },
      {
        path: 'legal',
        name: LEGAL,
        component: Legal,
        meta: {
          title: NON_NAV_PAGES.LEGAL,
        },
      },
      {
        path: 'search',
        name: SEARCH_RESULT_NOT_FOUND,
        component: Search,
        meta: {
          title: NON_NAV_PAGES.SEARCH,
        },
      },
      {
        path: 'search',
        name: SEARCH_RESULT_FOUND,
        props: true,
        component: Search,
        meta: {
          title: NON_NAV_PAGES.SEARCH,
        },
      },
    ],
  },
];
